import { InvoiceSummaryDto } from 'src/generated/services/TFinancialApi';

export interface DisputeResultProps {
  invoiceSummary: InvoiceSummaryDto;
}

export enum MainDetailsTabsIndex {
  APPROVALS = 0,
  DEVIATIONS = 1,
  DISPUTE_RESULT = 2,
}

export interface MainDetailsTabsProps {
  tabIndex: MainDetailsTabsIndex;
  onChange(index: MainDetailsTabsIndex): void;
  invoiceSummary: InvoiceSummaryDto;
}
